import { css } from '@emotion/react'
import { gemVar, Spacing, ThemedColors } from '@opallabs/gem'

export const container = css({
  display: 'flex',
  flexFlow: 'column wrap',
  padding: Spacing.XS * 3,
  rowGap: Spacing.XS * 3,
})

export const loaderContainer = css({
  inlineSize: 284,
  minBlockSize: 129,
  padding: Spacing.XS * 3,
})

export const membersAndSpaces = css({
  alignItems: 'center',
  columnGap: Spacing.XS,
  display: 'flex',
  flexFlow: 'row nowrap',

  span: {
    color: gemVar(ThemedColors.TextPrimary),
  },
})
